<div class="kontainer">
  <i [class]="ikon()"></i>
  <div class="melding">
    <ng-content/>
  </div>
</div>
